import { ReactNode } from "react";

import { Box } from "@mui/material";

import { TextButton } from "../../buttons";
import { Row } from "../../containers";
import { useAppPalette } from "../../../theme";

interface MobileSelectBarProps {
    onClear: () => void;
    bulkActionNode?: ReactNode;
    /** Offset below the fixed app header so the bar sticks under it, not behind it. */
    stickyTop?: number | string;
}

// Sticky select-mode bar: full-width bulk-action node (carries the count) with Clear to its right.
export function MobileSelectBar({ onClear, bulkActionNode, stickyTop = 0 }: MobileSelectBarProps) {
    const { background } = useAppPalette();
    return (
        <Box
            sx={{
                position: "sticky",
                top: stickyTop,
                zIndex: 2,
                backgroundColor: background,
                py: 1
            }}
        >
            <Row sx={{ alignItems: "center", gap: 2 }}>
                <Box sx={{ flex: 1, minWidth: 0, "& button": { width: "100%" } }}>{bulkActionNode}</Box>
                <TextButton color="secondary" variant="body1" onClick={onClear}>
                    Clear
                </TextButton>
            </Row>
        </Box>
    );
}
